
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/microsoft-teams",
      function () {
        return require("private-next-pages/destinations/microsoft-teams.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/microsoft-teams"])
      });
    }
  